import { bunja } from 'bunja';
import { useBunja } from 'bunja/react';
import { useAtomValue } from 'jotai';
import { RefObject } from 'react';

import { MessageKey, i18nBunja } from '@flipster/i18n';
import { observeIntersectionOnce, useIntersection } from '@flipster/react/misc/browser/intersection';
import { JotaiStoreScope } from '@flipster/utils/bunja-jotai';
import segment from '@flipster/utils/segment';

import { copyTradingBunja } from '../state';

export const CopyTradingSectionSegmentTrack = ({ ref }: { ref: RefObject<HTMLElement | null> }) => {
  const { topMasterAtom } = useBunja(copyTradingBunja);
  const topMaster = useAtomValue(topMasterAtom);
  useIntersection(
    ref,
    observeIntersectionOnce(() => {
      segment.track('copytrading_market_screen_impression', {
        master_nickname: topMaster?.nickname,
        page_type: 'market_page',
      });
    }),
  );
  return null;
};

export const copyTradingSectionSegmentBunja = bunja(() => {
  const store = bunja.use(JotaiStoreScope);
  const { getT } = bunja.use(i18nBunja);
  const t = getT();
  const { topMasterAtom } = bunja.use(copyTradingBunja);
  function trackCopyTradingSectionViewPerformanceClick(key: MessageKey) {
    const topMaster = store.get(topMasterAtom);
    if (!topMaster) return;
    segment.track('copytrading_market_screen_click_view', {
      master_nickname: topMaster.nickname,
      page_type: 'market_page',
      banner_title: t(key),
    });
  }
  return { trackCopyTradingSectionViewPerformanceClick };
});
copyTradingSectionSegmentBunja.debugLabel = 'copyTradingSectionSegmentBunja';
